<div class="main-container col-sm-12">
    <div class="name">{{name}}</div>
    <div class="col-sm-12 text-right">{{value}}</div>
</div>
